<template>
  <nav class="w-container mx-auto text-white flex-grow-0 absolute z-10">
    <ul class="flex w-full justify-between">
      <NavBarLink to="/" name="HOME" />
      <NavBarLink to="/floors" name="FLOORS" />
      <NavBarLink to="/configure" name="CONFIGURE" :enabled="canSelectConfigure"/>
      <NavBarLink to="/finishes" name="FINISHES" />
      <NavBarLink to="/your-design" name="YOUR DESIGN" :enabled="canSelectYourDesign" />
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import NavBarLink from '@/components/NavBarLink.vue'
export default {
  name: 'NavBar',
  components: {
    NavBarLink
  },
  computed: {
    ...mapGetters([
      'canSelectConfigure',
      'canSelectYourDesign'
    ])
  }
}
</script>
